/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DeploymentCreatedDtoDeployment } from './DeploymentCreatedDtoDeployment';
import {
    DeploymentCreatedDtoDeploymentFromJSON,
    DeploymentCreatedDtoDeploymentFromJSONTyped,
    DeploymentCreatedDtoDeploymentToJSON,
} from './DeploymentCreatedDtoDeployment';

/**
 * 
 * @export
 * @interface DeploymentCreatedDto
 */
export interface DeploymentCreatedDto {
    /**
     * 
     * @type {DeploymentCreatedDtoDeployment}
     * @memberof DeploymentCreatedDto
     */
    deployment: DeploymentCreatedDtoDeployment | null;
    /**
     * The redirect URL if the deployment cannot be completed automatically.
     * @type {string}
     * @memberof DeploymentCreatedDto
     */
    redirectUrl: string | null;
}

/**
 * Check if a given object implements the DeploymentCreatedDto interface.
 */
export function instanceOfDeploymentCreatedDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "deployment" in value;
    isInstance = isInstance && "redirectUrl" in value;

    return isInstance;
}

export function DeploymentCreatedDtoFromJSON(json: any): DeploymentCreatedDto {
    return DeploymentCreatedDtoFromJSONTyped(json, false);
}

export function DeploymentCreatedDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeploymentCreatedDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'deployment': DeploymentCreatedDtoDeploymentFromJSON(json['deployment']),
        'redirectUrl': json['redirectUrl'],
    };
}

export function DeploymentCreatedDtoToJSON(value?: DeploymentCreatedDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'deployment': DeploymentCreatedDtoDeploymentToJSON(value.deployment),
        'redirectUrl': value.redirectUrl,
    };
}

